import { Link } from 'react-router-dom';
import { ButtonContainerV1 } from './BaseButton.style';

const BaseButtonV1 = props => {
  const { href, to, innerRef } = props;

  if (href) {
    return <ButtonContainerV1 as="a" ref={innerRef} {...props} />;
  }

  if (to) {
    return <ButtonContainerV1 as={Link} ref={innerRef} {...props} />;
  }

  return <ButtonContainerV1 as="button" ref={innerRef} type="button" {...props} />;
};

export default BaseButtonV1;
